import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  deleteResourcePoolPolicy(rpId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/resourcepool/' + rpId + '/policy';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }

  deleteVmPolicy(vmId, vcId) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vc/' + vcId + '/vm/' + vmId + '/policy';
    return this.http
      .delete(url)
      .map(
        (res: any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/delete-policy/delete-policy.service.ts